import React from 'react';
import { GrayBackground, Page } from 'components/base/layout-components';
import styled from 'styled-components';
import NotConnectedState from 'components/NotConnectedState';
import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
import Icon from 'components/base/Icon';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import TeamsSelectTeamEmptyState from 'images/teams-select-team-empty-state.jpg';
import sunglassesDudesImg from 'images/characters/sunglasses-dudes.svg';
import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import useRBACPermissions from 'views/root/views/home/hooks/useRBACPermissions';
import useTeams from 'views/root/views/home/views/settings/views/ContributorsAndTeams/Teams/useTeams';

const StyledPage = styled(Page)`
  height: 100%;
`;

const StyledBackground = styled(GrayBackground)`
  overflow: hidden;
`;

const AllContributorsTeamsEmptyState = () => {
  const { onConfigureTeam } = useTeams();
  const myAccount = useSelector(myAccountSelector);
  const { isPermitted } = useRBACPermissions();

  const onCreateTeamClick = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.TEAMS,
      click_type: TRACKING.CLICK.ADD_TEAM
    });
    onConfigureTeam({ isSelectTeamId: true });
  };

  const canEdit = myAccount.type_id !== ACCOUNT_TYPES_MAP.Viewer;

  const props = {
    notConnectedImg: TeamsSelectTeamEmptyState,
    title: 'Teams is a team view',
    info:
      canEdit && isPermitted
        ? 'Select a team from the list above, or'
        : 'Select a team from the list above',
    afterButtonInfo:
      canEdit &&
      'After setting up, you will need to connect your team to a project management tool',
    image: sunglassesDudesImg,
    buttons:
      canEdit && isPermitted
        ? [
            {
              text: 'Create team',
              icon: <Icon name='TeamsPeopleIcon' color='nepal' />,
              onClick: onCreateTeamClick
            }
          ]
        : []
  };

  return (
    <StyledPage>
      <StyledBackground>
        <NotConnectedState {...props} />
      </StyledBackground>
    </StyledPage>
  );
};

export default AllContributorsTeamsEmptyState;
